import isEmpty from "lodash.isempty";
import omit from "lodash.omit";

import { baseInfluenceImpactGroup } from "./metricLabels/constants";

export const initGroupStatus = (tab, initTab) => {
  const { buildCurves = initTab.buildCurves, flightsTable = initTab.flightsTable } = tab;
  const { groupStatuses: initCurvesGroupStatuses } = buildCurves;
  const { groupStatuses: initTableGroupStatuses } = flightsTable;

  const curvesGroupStatuses = initCurvesGroupStatuses.map(({ label }) => ({
    label,
    isOpen: !isEmpty(
      buildCurves.series &&
        buildCurves.series.filter(([groupTitle, metrics]) => label === groupTitle && !isEmpty(metrics))
    )
  }));
  const tableGroupStatuses = initTableGroupStatuses.map(({ label }) => ({
    label,
    isOpen: !isEmpty(
      flightsTable.columns &&
        flightsTable.columns.filter(([groupTitle, metrics]) => label === groupTitle && !isEmpty(metrics))
    )
  }));
  return {
    ...tab,
    buildCurves: {
      ...tab.buildCurves,
      groupStatuses: curvesGroupStatuses
    },
    flightsTable: {
      ...tab.flightsTable,
      groupStatuses: tableGroupStatuses
    }
  };
};

export const clearDataFromPriceAdjExtraKeys = data =>
  data.map(influence => omit(influence, Object.keys(baseInfluenceImpactGroup())));
